import React from 'react'
// import img from './characters.png'

const Player = ({player, category}) => {

    return (
      <div className="SmallBadge">
      <div className="row">
        <div className="col-2">
            <img src={player.foto.fields.file.url} alt="player" className="m-2 rounded-circle playerPic"/>
        </div>
        <div className="col-10">
          <div className="rightContainer">
              <h5 className="mt-3"><b>{player.nombre}</b></h5>
              <h6 className="">Categoría: {category}</h6>
          </div>
        </div>
      </div>
    </div>
        );
      }
export default Player;